const FileName = "";
const getFileName = (state = FileName, action) => {
    if(action.type === "SET_FILENAME"){
        state   = action.fileName
    }
    return state;
}

export default getFileName;